import React, { useState } from "react";
import { BackTop, Skeleton, Tabs } from "antd";
import styles from "./index.module.scss";
import classNames from "classnames";
import QueryForm from "./Components/QueryForm";
import AskList from "./Components/AskList";
import useRequest from "../../../Utils/useRequest";
import { BusinessKey, queryAskList } from "../../../API/discuss";
import useBatchPicker from "../../main/utils/useBatchPicker";
import useModalHandler from "../../../Utils/v3/useModalHandler";
import SetNoticeModal from "../Components/SetNoticeModal";

export default function PageAskTeacherMain() {
    const [query, setQuery] = useState("");
    const [keyword, setKeyword] = useState("");
    const [sort, setSort] = useState<BooleanValue>("0");
    const { batch } = useBatchPicker();
    const [data, { loading }, reload] = useRequest(
        async () => queryAskList({ query, keyword, sort }, batch),
        {},
        [query, keyword, sort]
    );

    const setModal = useModalHandler({
        component: SetNoticeModal
    });

    function openModal() {
        setModal.open({
            businessKey: BusinessKey.Aks,
            onSuccess: () => setModal.close()
        });
    }

    // const tabBarExtraContent = (
    //     <Button type="link" icon="setting" onClick={openModal}>
    //         设置
    //     </Button>
    // );

    return (
        <div className={classNames(styles.root, "container")}>
            <Tabs
                className={styles.tabs}
                animated={false}
                destroyInactiveTabPane
                defaultActiveKey=""
                onChange={setQuery}>
                <Tabs.TabPane key="" tab="全部" />
                <Tabs.TabPane key="1" tab="我提问的" />
                <Tabs.TabPane key="2" tab="我参与的" />
            </Tabs>
            <QueryForm
                onChange={setKeyword}
                setSort={setSort}
                sort={sort}
                reload={reload}
            />

            {loading && (
                <div className={styles.ske}>
                    {[1, 2, 3].map(item => (
                        <div key={item}>
                            <Skeleton avatar />
                        </div>
                    ))}
                </div>
            )}

            {!loading && <AskList data={data || []} reload={reload} />}

            <BackTop />

            {setModal.render()}
        </div>
    );
}
